import { render, staticRenderFns } from "./Supervision.vue?vue&type=template&id=164773be&"
import script from "./Supervision.vue?vue&type=script&lang=js&"
export * from "./Supervision.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports